module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27048",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.7004",
      "conversations-error-reporting": "static-1.8274",
      "conversations-internal-pub-sub": "static-1.15359",
      "conversations-internal-schema": "static-1.12002",
      "conversations-message-history": "static-1.10641",
      "conversations-test-sdk": "static-1.9814",
      "conversations-visitor-experience-components": "static-1.20411",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4880",
      "hs-test-utils": "static-1.7347",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10870",
      "I18n": "static-7.1452",
      "jasmine-immutable": "static-1.2320",
      "jasmine-runner": "static-1.5774",
      "quartz": "static-1.6167",
      "react-dlb": "static-1.62",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.3894",
      "viral-links-lib": "static-1.6264",
      "visitor-ui-component-library": "static-1.5514",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3921",
      "atom": "static-1.4502",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4149",
      "conversations-infrastructure": "static-1.8297",
      "conversations-prop-types": "static-1.6784",
      "conversations-visibility-tools": "static-1.5125",
      "conversations-visitor-message-history": "static-1.19148",
      "cssUtils": "static-1.602",
      "enviro": "static-4.328",
      "flux-actions": "static-1.287",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15958",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4741",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3732",
      "sanitize-text": "static-1.7507",
      "signup-constants": "static-1.17591",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.476",
      "usage-tracker": "static-1.6783",
      "usage-tracker-core": "static-1.6633",
      "usage-tracker-multi": "static-1.5197",
      "usage-tracker-public": "static-1.6594",
      "visitor-ui-component-library-icons": "static-1.5325",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2887",
      "moment": "static-3.26",
      "quartz-core": "static-1.5386",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4212",
      "foundations-components": "static-1.6864",
      "foundations-theming": "static-1.3697",
      "UIComponents": "static-3.7817",
      "cv-backend-services": "static-1.1341",
      "immutable-less": "static-1.3914",
      "conversations-skeleton-state": "static-1.6718",
      "crm-events-viz-core": "static-1.31249",
      "icons": "static-2.596",
      "react-input-autosize": "static-2.17",
      "tanstack-virtual": "static-1.15",
      "rpc-client-utils": "static-1.4051",
      "ui-images": "static-2.967",
      "permission-components": "static-1.4695",
      "react-virtualized": "static-2.82",
      "HeadJS": "static-2.623",
      "framer-motion": "static-1.53",
      "hs-test-utils-bend-plugin": "static-1.2458",
      "msw": "static-1.39",
      "testing-library": "static-1.135",
      "i18n-data": "static-1.208",
      "moment-timezone": "static-5.68",
      "jasmine": "static-4.3664",
      "quartz-core-utils": "static-1.3034",
      "signup-ui-url-generator": "static-2.7432",
      "HubStyle": "static-2.11178",
      "sassPrefix": "static-1.142",
      "csstype": "static-1.50",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5200",
      "dispatcher": "static-1.122",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.699",
      "hub-http-shared-msw-handlers": "static-1.8462",
      "hubspotter-http": "static-1.4002",
      "hubspotter-http-shared-msw-handlers": "static-1.8460",
      "mobile-manifest-mixins": "static-1.395",
      "platform-navigation-bootstrap": "static-1.11864",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.334",
      "hs-story-utils": "static-1.8720",
      "bend-plugin-foundations-components": "static-1.3133",
      "floating-ui": "static-1.41",
      "foundations-theming-specialty": "static-1.1413",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2180",
      "foundations-theming-base": "static-1.2682",
      "ts-schema": "static-1.3530",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.1834",
      "content-assistance-lib": "static-1.6988",
      "crm-component-utils": "static-1.37429",
      "crm-display-components": "static-1.23179",
      "crm-fe-perf": "static-1.22319",
      "crm-links": "static-1.5546",
      "crm-message-bus": "static-1.41252",
      "crm-search-service-types": "static-1.627",
      "crm-source-interpretation-lib": "static-1.4644",
      "customer-data-communicator": "static-1.43799",
      "customer-data-email": "static-1.16940",
      "customer-data-filters-ui": "static-1.37457",
      "customer-data-objects": "static-1.6998",
      "customer-data-objects-ui-components": "static-1.12331",
      "customer-data-properties": "static-1.49527",
      "customer-data-rte": "static-1.31544",
      "customer-data-ui-utilities": "static-1.9126",
      "data-fetching-client": "static-1.9023",
      "draft-plugins": "static-2.20533",
      "file-manager-components": "static-1.21795",
      "FileManagerCore": "static-1.37294",
      "frontend-preferences-client": "static-1.7292",
      "hubspot-apollo-client": "static-1.4179",
      "hubspot-prosemirror": "static-1.16509",
      "object-comments-thread-lib": "static-1.9056",
      "reference-resolvers-lite": "static-1.7406",
      "ui-addon-upgrades": "static-9.16983",
      "universal-associations-select": "static-1.10285",
      "platform-infra-nav-components": "static-1.7112",
      "graphql": "static-1.67",
      "ai-components-ui-library": "static-1.7323",
      "superstore": "static-1.4073",
      "ui-addon-video-player": "static-1.8107",
      "ui-coaching-tips": "static-1.26746",
      "card-properties-lib": "static-1.42396",
      "crm-actions": "static-1.5559",
      "crm-cards-data": "static-1.357",
      "crm-cards-sdk": "static-1.41701",
      "customer-data-properties-shared-msw-handlers": "static-1.7789",
      "customer-data-property-utils": "static-1.7323",
      "customer-data-tracking": "static-1.6202",
      "framework-data-schema-resolvers": "static-1.6246",
      "usage-tracker-container": "static-1.6773",
      "framework-data-table": "static-2.10528",
      "location-customization-utils-lib": "static-1.7319",
      "calling-error-reporting": "static-1.30650",
      "calling-internal-common": "static-1.30644",
      "calling-usage-tracker": "static-1.5850",
      "crm_data": "static-4.89991",
      "crm_schema": "static-3.90030",
      "crm-legacy-global-containers": "static-1.23147",
      "customer-data-content": "static-1.26094",
      "draft-content-plugins": "static-1.26893",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.22882",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22581",
      "EmailSignatureEditor": "static-1.23116",
      "FileManagerLib": "static-1.37435",
      "hubspot-prosemirror-plugins": "static-1.16501",
      "integration-settings-components": "static-1.13483",
      "integrations-lib": "static-1.14215",
      "integrations-tracking-lib": "static-1.5002",
      "native-integrations-shared-strings": "static-1.7159",
      "nav-meta": "static-1.27838",
      "outreach-assistant-email-generation": "static-1.5021",
      "property-translator": "static-1.4724",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.35882",
      "react-colorpicker": "static-2.9613",
      "react-dnd-compat": "static-1.4026",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7527",
      "rich-text-lib": "static-1.18701",
      "sales-email-signature-service-client": "static-1.3280",
      "sequences-lib": "static-1.7109",
      "timezone-utils": "static-2.4552",
      "ui-addon-i18n": "static-1.10343",
      "ui-addon-iframeable": "static-1.8271",
      "ui-business-units-lib": "static-1.8280",
      "ui-gdpr-components": "static-1.9586",
      "ui-shepherd-react": "static-3.9425",
      "user-context": "static-1.4544",
      "whatsapp-sending-lib": "static-1.3722",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4082",
      "salesImages": "static-1.511",
      "customer-data-filters-ui-msw-helpers": "static-1.19891",
      "customer-data-reference-ui-components": "static-1.12424",
      "FormUrlGenerator": "static-2.4058",
      "framework-builder-read-service-client": "static-1.3478",
      "framework-data-schema-quick-fetch": "static-1.6151",
      "inbound-db-meta-service-client": "static-1.3137",
      "inbound-db-properties-service-client": "static-1.3358",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.368",
      "onboarding-tours": "static-1.15732",
      "SharedI18nStrings": "static-1.171",
      "ui-addon-teams": "static-1.20708",
      "calling-cross-tab-library": "static-1.18645",
      "calling-global-api": "static-1.62327",
      "calling-integration-cross-tab": "static-1.21413",
      "calling-lifecycle-internal": "static-1.63709",
      "calling-lifecycle-messages": "static-1.56003",
      "conditional-properties-service-client": "static-1.3318",
      "external-options-client-types": "static-1.3526",
      "google-libphonenumber": "static-1.21",
      "inbounddb-objects-service-types": "static-1.3629",
      "object-builder-ui-client": "static-1.46677",
      "pipeline-validation-client-types": "static-1.3323",
      "smart-property-lib": "static-1.4463",
      "tiered-pricing": "static-1.252",
      "ui-addon-form-validation": "static-1.10379",
      "directed-graph": "static-1.289",
      "event-emitter": "static-1.352",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3466",
      "video-components-external": "static-1.9437",
      "video-data-lib": "static-1.33095",
      "audio-components": "static-1.5128",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.34946",
      "video-components": "static-1.11440",
      "video-embed": "static-1.33929",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23580",
      "knowledge-content-types": "static-1.8036",
      "payment-link-components": "static-1.21922",
      "ui-addon-emoji-picker": "static-1.9287",
      "call-summary": "static-1.37018",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8608",
      "batch-promise": "static-1.951",
      "feature-store-service-types": "static-1.4004",
      "growth-monetization-service-types": "static-1.4011",
      "merchandise-lib": "static-1.234",
      "self-service-api": "static-1.9607",
      "upgrade-management-service-types": "static-1.3995",
      "chatspot-client-types": "static-1.10046",
      "chatspot-core": "static-1.18924",
      "ContentUtils": "static-1.66370",
      "copilot-toolkit": "static-1.9457",
      "growth-onboarding-feedback-components": "static-1.5854",
      "customer-data-sidebar": "static-2.44320",
      "enrichment-properties-lib": "static-1.13581",
      "persist-promise": "static-1.3109",
      "crm-pipelines-api-client-types": "static-1.3503",
      "customer-data-associations": "static-1.6585",
      "reporting-data": "static-1.64953",
      "ui-addon-draggable": "static-3.4212",
      "crm-record-cards-service-types": "static-1.3095",
      "crm_universal": "static-1.21163",
      "SalesContentIndexUI": "static-3.8164",
      "signup-ui-lego-core": "static-1.19601",
      "content-embed-lib": "static-1.6694",
      "data-model-builder-lib": "static-1.10254",
      "remote-ui": "static-1.52",
      "ui-components-test-utils": "static-1.5008",
      "ui-extensions-remote-renderer": "static-1.15445",
      "universal-page-editor-lib": "static-1.2403",
      "integrations-error-boundary-lib": "static-1.11630",
      "laboratory-lib": "static-3.6543",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9821",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8217",
      "messaging-types-lib": "static-1.44045",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15333",
      "sequences-client-types-lib": "static-1.6966",
      "foundations-components-test-utils": "static-1.4348",
      "magpie-lib": "static-1.5006",
      "navigation-messaging": "static-1.5528",
      "getting-started-shared-tasks": "static-1.16736",
      "getting-started-shared-tasks-store": "static-1.15854",
      "whatsapp-management-lib": "static-1.6881",
      "growth-data-modal": "static-1.4665",
      "growth-onboarding-confetti": "static-1.2431",
      "growth-onboarding-next-action-utils": "static-1.756",
      "navigation-components": "static-1.16201",
      "ui-shepherd-tracker": "static-1.6806",
      "shared-worker-versioning": "static-1.10425",
      "worker-connection-library": "static-1.15883",
      "calling-orchestration-shared-library": "static-1.33557",
      "onboarding-scopes": "static-1.5872",
      "breeze-intelligence-kit": "static-1.4701",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8545",
      "fsm": "static-1.3049",
      "policy-lib": "static-1.6116",
      "react-tinymce": "static-1.53488",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.52614",
      "tinymce-plugins": "static-1.55728",
      "tinymce-themes": "static-1.54584",
      "commerce-products-lib": "static-1.7649",
      "content-media-composition-data-lib": "static-1.9654",
      "content-media-compositions": "static-2.13661",
      "idb-keyval": "static-1.29",
      "magpie-types": "static-1.4466",
      "media-bridge-lib": "static-1.17933",
      "content-icons-ui": "static-1.2016",
      "social-insights-client-types": "static-1.20308",
      "outpost": "static-1.3678",
      "commerce-analytics-service-client": "static-1.3014",
      "ui-addon-opt": "static-4.7855",
      "commerce-tours-lib": "static-1.5077",
      "growth-onboarding-reliability": "static-1.4479",
      "sales-checkout-service-client": "static-1.3026",
      "ai-addon-copilot-preview": "static-1.6535",
      "wootric-nps": "static-1.6175",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4109",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2348",
      "card-payment-highlight-lib": "static-1.35452",
      "card-subscription-highlight-lib": "static-1.37766",
      "commerce-billing-lib": "static-1.17417",
      "commerce-contract-lib": "static-1.9937",
      "crm_components": "static-3.89991",
      "invoices-highlight-card-lib": "static-1.52773",
      "orders-highlight-card-lib": "static-1.19982",
      "products-highlight-card-lib": "static-1.15934",
      "project-storage": "static-1.4045",
      "quotes-highlight-card-lib": "static-1.69797",
      "usage-based-billing-components-lib": "static-1.7027",
      "reporting-client-types": "static-1.2251",
      "react-flip-move": "static-1.55",
      "FireAlarmUi": "static-1.4026",
      "sales-templates-service-types-lib": "static-1.3588",
      "ui-asset-management-lib": "static-1.10073",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8542",
      "collaboration-sidebar": "static-1.56157",
      "data-model-commons-lib": "static-1.10876",
      "feedback-loader": "static-1.28023",
      "final-form": "static-1.53",
      "html-to-image": "static-1.38",
      "object-definition-builder-lib": "static-1.6334",
      "property-management-iframe": "static-1.10928",
      "reactflow": "static-1.45",
      "used-in-list-lib": "static-1.6189",
      "visual-association": "static-1.5145",
      "highcharts": "static-8.89",
      "reporting-visualizations": "static-1.57030",
      "ui-extensibility-client-types": "static-1.3399",
      "automation-platform-service-types": "static-1.2319",
      "ContentData": "static-1.66445",
      "email-portal-health-service-types": "static-1.378",
      "marketing-email-service-types": "static-1.1623",
      "reactive-lib": "static-1.97",
      "short-messages-app-service-client": "static-1.3393",
      "ui-tool-access": "static-1.9433",
      "calling-orchestration-schema": "static-1.33782",
      "trellis-story-utils": "static-1.3900",
      "storybook-react": "static-1.16",
      "hub-http-contrib": "static-1.2454",
      "interframe": "static-3.4117",
      "tinymce-data": "static-1.38699",
      "ui-addon-sales-email": "static-1.4557",
      "codemirror": "static-5.80",
      "layout-dnd-components": "static-1.11360",
      "layout-dnd-utils": "static-1.10335",
      "react-codemirror": "static-1.9962",
      "ui-brand-identity-lib": "static-1.12250",
      "NamespacedHubStyle": "static-2.8609",
      "products-iframe-lib": "static-1.6265",
      "products-ui-components-shared-msw-handlers": "static-1.8844",
      "hls.js": "static-1.24",
      "js-cookie": "static-1.18",
      "onboarding-tours-client": "static-1.3946",
      "ai-rendering-library": "static-1.8123",
      "ai-settings-ui-library": "static-1.6731",
      "chirp-fetch": "static-1.1346",
      "copilot-plugins": "static-1.9430",
      "commerce-shared-components-lib": "static-1.16881",
      "commerce-subscription-lib": "static-1.35343",
      "commerce-tools-ui-lib": "static-1.8914",
      "usage-tracker-session-replay": "static-1.4469",
      "utility-belt": "static-1.1851",
      "payments-enrollment-embed-lib": "static-1.20666",
      "quotes-ui-lib": "static-1.78513",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6008",
      "invoices-ui-lib": "static-1.52789",
      "commerce-products-api": "static-1.1296",
      "SafeStorage": "static-1.3734",
      "invoices-iframe-lib": "static-1.54847",
      "quotes-modal-lib": "static-1.100470",
      "reporting-ui-components": "static-2.62227",
      "subscription-experience-data-types": "static-1.13860",
      "association-translator": "static-1.2510",
      "crm-settings-header-lib": "static-1.7556",
      "settings-ui-nav": "static-2.9495",
      "chatspot-widget-iframe": "static-1.18916",
      "collaboration-sidebar-common": "static-1.953",
      "property-management-common": "static-1.3215",
      "d3": "static-1.7",
      "crm-object-map": "static-1.4307",
      "advanced-menus-core": "static-1.14196",
      "advanced-menus-lib": "static-1.11261",
      "ExportDialog": "static-6.9824",
      "ui-memberships-settings-lib": "static-1.32163",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8660",
      "browser-eslint": "static-2.57",
      "multi-currency-client-types": "static-1.3139",
      "sales-views-client-types": "static-1.3612",
      "highlight.js": "static-1.45",
      "reporting-action-components": "static-1.39606",
      "ui-addon-react-router-dom": "static-1.8956",
      "growth-onboarding-empty-states": "static-1.4867",
      "InboxConnectUtils": "static-4.13214",
      "payments-post-enroll-local-storage-lib": "static-1.4426",
      "qrcode-generator": "static-1.52",
      "trials-service-types": "static-1.3412",
      "amplitude-session-replay-browser": "static-1.45",
      "marketplace-ui-apps-core": "static-1.16360",
      "stripe-embedded-components": "static-1.6499",
      "products-ui-components": "static-1.38169",
      "totals-ui-components": "static-1.21930",
      "reporting-plugins": "static-1.9304",
      "reporting-reports": "static-1.64633",
      "reporting-snowflake": "static-1.53573",
      "crm-index-visualization-object-layout": "static-1.3954",
      "crm-object-search-query-utilities": "static-1.8260",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14195",
      "simple-menus-lib": "static-1.15712",
      "dashboard-lib": "static-1.79151",
      "share-with-third-party-component-lib": "static-1.8059",
      "developer-experience-shared-components": "static-1.9705",
      "marketplace-ui-client-types": "static-1.15233",
      "marketplace-ui-common": "static-1.17826",
      "ui-addon-integrations-directory-panel": "static-2.7404",
      "stripe-connect-js": "static-1.43",
      "property-description-translator": "static-1.3176",
      "commerce-totals-service-types": "static-1.3266",
      "campaign-roi-lib": "static-1.7086",
      "reporting-datasets-permissions-lib": "static-1.11741",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3341",
      "oauth-service-types": "static-1.3598",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27048",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.7004",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8274",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15359",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12002",
      "conversations-message-history": "/conversations-message-history/static-1.10641",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9814",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20411",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4880",
      "hs-test-utils": "/hs-test-utils/static-1.7347",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10870",
      "I18n": "/I18n/static-7.1452",
      "jasmine-immutable": "/jasmine-immutable/static-1.2320",
      "jasmine-runner": "/jasmine-runner/static-1.5774",
      "quartz": "/quartz/static-1.6167",
      "react-dlb": "/react-dlb/static-1.62",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.3894",
      "viral-links-lib": "/viral-links-lib/static-1.6264",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5514",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3921",
      "atom": "/atom/static-1.4502",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4149",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8297",
      "conversations-prop-types": "/conversations-prop-types/static-1.6784",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5125",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19148",
      "cssUtils": "/cssUtils/static-1.602",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.287",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15958",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4741",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3732",
      "sanitize-text": "/sanitize-text/static-1.7507",
      "signup-constants": "/signup-constants/static-1.17591",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.476",
      "usage-tracker": "/usage-tracker/static-1.6783",
      "usage-tracker-core": "/usage-tracker-core/static-1.6633",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5197",
      "usage-tracker-public": "/usage-tracker-public/static-1.6594",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5325",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2887",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5386",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4212",
      "foundations-components": "/foundations-components/static-1.6864",
      "foundations-theming": "/foundations-theming/static-1.3697",
      "UIComponents": "/UIComponents/static-3.7817",
      "cv-backend-services": "/cv-backend-services/static-1.1341",
      "immutable-less": "/immutable-less/static-1.3914",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6718",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31249",
      "icons": "/icons/static-2.596",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "tanstack-virtual": "/tanstack-virtual/static-1.15",
      "rpc-client-utils": "/rpc-client-utils/static-1.4051",
      "ui-images": "/ui-images/static-2.967",
      "permission-components": "/permission-components/static-1.4695",
      "react-virtualized": "/react-virtualized/static-2.82",
      "HeadJS": "/HeadJS/static-2.623",
      "framer-motion": "/framer-motion/static-1.53",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2458",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.135",
      "i18n-data": "/i18n-data/static-1.208",
      "moment-timezone": "/moment-timezone/static-5.68",
      "jasmine": "/jasmine/static-4.3664",
      "quartz-core-utils": "/quartz-core-utils/static-1.3034",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7432",
      "HubStyle": "/HubStyle/static-2.11178",
      "sassPrefix": "/sassPrefix/static-1.142",
      "csstype": "/csstype/static-1.50",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5200",
      "dispatcher": "/dispatcher/static-1.122",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.699",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8462",
      "hubspotter-http": "/hubspotter-http/static-1.4002",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8460",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.395",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11864",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.334",
      "hs-story-utils": "/hs-story-utils/static-1.8720",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3133",
      "floating-ui": "/floating-ui/static-1.41",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1413",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2180",
      "foundations-theming-base": "/foundations-theming-base/static-1.2682",
      "ts-schema": "/ts-schema/static-1.3530",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.1834",
      "content-assistance-lib": "/content-assistance-lib/static-1.6988",
      "crm-component-utils": "/crm-component-utils/static-1.37429",
      "crm-display-components": "/crm-display-components/static-1.23179",
      "crm-fe-perf": "/crm-fe-perf/static-1.22319",
      "crm-links": "/crm-links/static-1.5546",
      "crm-message-bus": "/crm-message-bus/static-1.41252",
      "crm-search-service-types": "/crm-search-service-types/static-1.627",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4644",
      "customer-data-communicator": "/customer-data-communicator/static-1.43799",
      "customer-data-email": "/customer-data-email/static-1.16940",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37457",
      "customer-data-objects": "/customer-data-objects/static-1.6998",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12331",
      "customer-data-properties": "/customer-data-properties/static-1.49527",
      "customer-data-rte": "/customer-data-rte/static-1.31544",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9126",
      "data-fetching-client": "/data-fetching-client/static-1.9023",
      "draft-plugins": "/draft-plugins/static-2.20533",
      "file-manager-components": "/file-manager-components/static-1.21795",
      "FileManagerCore": "/FileManagerCore/static-1.37294",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7292",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4179",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16509",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9056",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7406",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16983",
      "universal-associations-select": "/universal-associations-select/static-1.10285",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7112",
      "graphql": "/graphql/static-1.67",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7323",
      "superstore": "/superstore/static-1.4073",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8107",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.26746",
      "card-properties-lib": "/card-properties-lib/static-1.42396",
      "crm-actions": "/crm-actions/static-1.5559",
      "crm-cards-data": "/crm-cards-data/static-1.357",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.41701",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.7789",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7323",
      "customer-data-tracking": "/customer-data-tracking/static-1.6202",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6246",
      "usage-tracker-container": "/usage-tracker-container/static-1.6773",
      "framework-data-table": "/framework-data-table/static-2.10528",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7319",
      "calling-error-reporting": "/calling-error-reporting/static-1.30650",
      "calling-internal-common": "/calling-internal-common/static-1.30644",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5850",
      "crm_data": "/crm_data/static-4.89991",
      "crm_schema": "/crm_schema/static-3.90030",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23147",
      "customer-data-content": "/customer-data-content/static-1.26094",
      "draft-content-plugins": "/draft-content-plugins/static-1.26893",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.22882",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22581",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23116",
      "FileManagerLib": "/FileManagerLib/static-1.37435",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16501",
      "integration-settings-components": "/integration-settings-components/static-1.13483",
      "integrations-lib": "/integrations-lib/static-1.14215",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5002",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7159",
      "nav-meta": "/nav-meta/static-1.27838",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5021",
      "property-translator": "/property-translator/static-1.4724",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.35882",
      "react-colorpicker": "/react-colorpicker/static-2.9613",
      "react-dnd-compat": "/react-dnd-compat/static-1.4026",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7527",
      "rich-text-lib": "/rich-text-lib/static-1.18701",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3280",
      "sequences-lib": "/sequences-lib/static-1.7109",
      "timezone-utils": "/timezone-utils/static-2.4552",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10343",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8271",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8280",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9586",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9425",
      "user-context": "/user-context/static-1.4544",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.3722",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4082",
      "salesImages": "/salesImages/static-1.511",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.19891",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12424",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4058",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3478",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6151",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3137",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3358",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.368",
      "onboarding-tours": "/onboarding-tours/static-1.15732",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.171",
      "ui-addon-teams": "/ui-addon-teams/static-1.20708",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18645",
      "calling-global-api": "/calling-global-api/static-1.62327",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.21413",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.63709",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56003",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3318",
      "external-options-client-types": "/external-options-client-types/static-1.3526",
      "google-libphonenumber": "/google-libphonenumber/static-1.21",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3629",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.46677",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3323",
      "smart-property-lib": "/smart-property-lib/static-1.4463",
      "tiered-pricing": "/tiered-pricing/static-1.252",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10379",
      "directed-graph": "/directed-graph/static-1.289",
      "event-emitter": "/event-emitter/static-1.352",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3466",
      "video-components-external": "/video-components-external/static-1.9437",
      "video-data-lib": "/video-data-lib/static-1.33095",
      "audio-components": "/audio-components/static-1.5128",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.34946",
      "video-components": "/video-components/static-1.11440",
      "video-embed": "/video-embed/static-1.33929",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23580",
      "knowledge-content-types": "/knowledge-content-types/static-1.8036",
      "payment-link-components": "/payment-link-components/static-1.21922",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9287",
      "call-summary": "/call-summary/static-1.37018",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8608",
      "batch-promise": "/batch-promise/static-1.951",
      "feature-store-service-types": "/feature-store-service-types/static-1.4004",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4011",
      "merchandise-lib": "/merchandise-lib/static-1.234",
      "self-service-api": "/self-service-api/static-1.9607",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3995",
      "chatspot-client-types": "/chatspot-client-types/static-1.10046",
      "chatspot-core": "/chatspot-core/static-1.18924",
      "ContentUtils": "/ContentUtils/static-1.66370",
      "copilot-toolkit": "/copilot-toolkit/static-1.9457",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5854",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44320",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13581",
      "persist-promise": "/persist-promise/static-1.3109",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3503",
      "customer-data-associations": "/customer-data-associations/static-1.6585",
      "reporting-data": "/reporting-data/static-1.64953",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4212",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3095",
      "crm_universal": "/crm_universal/static-1.21163",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8164",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19601",
      "content-embed-lib": "/content-embed-lib/static-1.6694",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10254",
      "remote-ui": "/remote-ui/static-1.52",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5008",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15445",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2403",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11630",
      "laboratory-lib": "/laboratory-lib/static-3.6543",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9821",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8217",
      "messaging-types-lib": "/messaging-types-lib/static-1.44045",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15333",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.6966",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4348",
      "magpie-lib": "/magpie-lib/static-1.5006",
      "navigation-messaging": "/navigation-messaging/static-1.5528",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.16736",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.15854",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.6881",
      "growth-data-modal": "/growth-data-modal/static-1.4665",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2431",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.756",
      "navigation-components": "/navigation-components/static-1.16201",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6806",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10425",
      "worker-connection-library": "/worker-connection-library/static-1.15883",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33557",
      "onboarding-scopes": "/onboarding-scopes/static-1.5872",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4701",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8545",
      "fsm": "/fsm/static-1.3049",
      "policy-lib": "/policy-lib/static-1.6116",
      "react-tinymce": "/react-tinymce/static-1.53488",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.52614",
      "tinymce-plugins": "/tinymce-plugins/static-1.55728",
      "tinymce-themes": "/tinymce-themes/static-1.54584",
      "commerce-products-lib": "/commerce-products-lib/static-1.7649",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.9654",
      "content-media-compositions": "/content-media-compositions/static-2.13661",
      "idb-keyval": "/idb-keyval/static-1.29",
      "magpie-types": "/magpie-types/static-1.4466",
      "media-bridge-lib": "/media-bridge-lib/static-1.17933",
      "content-icons-ui": "/content-icons-ui/static-1.2016",
      "social-insights-client-types": "/social-insights-client-types/static-1.20308",
      "outpost": "/outpost/static-1.3678",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3014",
      "ui-addon-opt": "/ui-addon-opt/static-4.7855",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5077",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4479",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3026",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6535",
      "wootric-nps": "/wootric-nps/static-1.6175",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4109",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2348",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35452",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.37766",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17417",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.9937",
      "crm_components": "/crm_components/static-3.89991",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.52773",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.19982",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.15934",
      "project-storage": "/project-storage/static-1.4045",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.69797",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7027",
      "reporting-client-types": "/reporting-client-types/static-1.2251",
      "react-flip-move": "/react-flip-move/static-1.55",
      "FireAlarmUi": "/FireAlarmUi/static-1.4026",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3588",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10073",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8542",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56157",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.10876",
      "feedback-loader": "/feedback-loader/static-1.28023",
      "final-form": "/final-form/static-1.53",
      "html-to-image": "/html-to-image/static-1.38",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6334",
      "property-management-iframe": "/property-management-iframe/static-1.10928",
      "reactflow": "/reactflow/static-1.45",
      "used-in-list-lib": "/used-in-list-lib/static-1.6189",
      "visual-association": "/visual-association/static-1.5145",
      "highcharts": "/highcharts/static-8.89",
      "reporting-visualizations": "/reporting-visualizations/static-1.57030",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3399",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2319",
      "ContentData": "/ContentData/static-1.66445",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.378",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1623",
      "reactive-lib": "/reactive-lib/static-1.97",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3393",
      "ui-tool-access": "/ui-tool-access/static-1.9433",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.33782",
      "trellis-story-utils": "/trellis-story-utils/static-1.3900",
      "storybook-react": "/storybook-react/static-1.16",
      "hub-http-contrib": "/hub-http-contrib/static-1.2454",
      "interframe": "/interframe/static-3.4117",
      "tinymce-data": "/tinymce-data/static-1.38699",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4557",
      "codemirror": "/codemirror/static-5.80",
      "layout-dnd-components": "/layout-dnd-components/static-1.11360",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10335",
      "react-codemirror": "/react-codemirror/static-1.9962",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12250",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8609",
      "products-iframe-lib": "/products-iframe-lib/static-1.6265",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.8844",
      "hls.js": "/hls.js/static-1.24",
      "js-cookie": "/js-cookie/static-1.18",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3946",
      "ai-rendering-library": "/ai-rendering-library/static-1.8123",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6731",
      "chirp-fetch": "/chirp-fetch/static-1.1346",
      "copilot-plugins": "/copilot-plugins/static-1.9430",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.16881",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35343",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.8914",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4469",
      "utility-belt": "/utility-belt/static-1.1851",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20666",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78513",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6008",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.52789",
      "commerce-products-api": "/commerce-products-api/static-1.1296",
      "SafeStorage": "/SafeStorage/static-1.3734",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.54847",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100470",
      "reporting-ui-components": "/reporting-ui-components/static-2.62227",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.13860",
      "association-translator": "/association-translator/static-1.2510",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7556",
      "settings-ui-nav": "/settings-ui-nav/static-2.9495",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.18916",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.953",
      "property-management-common": "/property-management-common/static-1.3215",
      "d3": "/d3/static-1.7",
      "crm-object-map": "/crm-object-map/static-1.4307",
      "advanced-menus-core": "/advanced-menus-core/static-1.14196",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11261",
      "ExportDialog": "/ExportDialog/static-6.9824",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32163",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8660",
      "browser-eslint": "/browser-eslint/static-2.57",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3139",
      "sales-views-client-types": "/sales-views-client-types/static-1.3612",
      "highlight.js": "/highlight.js/static-1.45",
      "reporting-action-components": "/reporting-action-components/static-1.39606",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8956",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4867",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13214",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4426",
      "qrcode-generator": "/qrcode-generator/static-1.52",
      "trials-service-types": "/trials-service-types/static-1.3412",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.45",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16360",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6499",
      "products-ui-components": "/products-ui-components/static-1.38169",
      "totals-ui-components": "/totals-ui-components/static-1.21930",
      "reporting-plugins": "/reporting-plugins/static-1.9304",
      "reporting-reports": "/reporting-reports/static-1.64633",
      "reporting-snowflake": "/reporting-snowflake/static-1.53573",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.3954",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.8260",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14195",
      "simple-menus-lib": "/simple-menus-lib/static-1.15712",
      "dashboard-lib": "/dashboard-lib/static-1.79151",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8059",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9705",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15233",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.17826",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7404",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "property-description-translator": "/property-description-translator/static-1.3176",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3266",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7086",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.11741",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3341",
      "oauth-service-types": "/oauth-service-types/static-1.3598",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};